import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { SpinnerComponent } from './spinner.component';

@Injectable()
export class SpinnerService {
  showSpinner = new Subject<any>();

  constructor() { }

  show() {
    this.showSpinner.next(true);
  }

  hide() {
    this.showSpinner.next(false);
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/shared/components/spinner/spinner.service.ts